<div
  class="slider"
  #slideInteraction
  (mouseenter)="pauseAutoSlideOnHover && pauseAutoplay($event)"
  (mouseleave)="pauseAutoSlideOnHover && startAutoPlay($event)"
>
  <div class="slider-body-wrapper">
    <ng-content></ng-content>
  </div>
</div>
<div class="slider-nav" *ngIf="hasPointNav">
  <div class="wrap">
    <a
      *ngFor="let tab of _items; let i = index"
      (click)="changeSlide(i); clearAutoSlide()"
      [ngClass]="{ active: selectedIndex === i }"
    ></a>
  </div>
</div>
<div class="arrow-nav" *ngIf="hasArrowNav">
  <button
    *ngIf="selectedIndex > 0"
    class="arrow prev"
    (click)="changeSlide('prev')"
    (mouseenter)="pauseAutoSlideOnHover && pauseAutoplay($event)"
    (mouseleave)="pauseAutoSlideOnHover && startAutoPlay($event)"
  >
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" [attr.fill]="arrowIconColor" />
        <path d="M0 0h24v24H0V0z" fill="none" />
      </svg>
    </span>
  </button>
  <button
    class="arrow next"
    (click)="changeSlide('next')"
    (mouseenter)="pauseAutoSlideOnHover && pauseAutoplay($event)"
    (mouseleave)="pauseAutoSlideOnHover && startAutoPlay($event)"
  >
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" [attr.fill]="arrowIconColor" />
        <path d="M0 0h24v24H0V0z" fill="none" />
      </svg>
    </span>
  </button>
</div>
